import cn from 'classnames';

export type StatusTypes =
    | 'approved'
    | 'initiated'
    | 'rejected'
    | 'canceled'
    | 'active'
    | 'inactive'
    | 'pending'
    | 'update';

export type StatusPillProps = {
    statusType: StatusTypes;
    statusText: string;
    className?: string;
};

type StatusColor = {
    [key in StatusTypes]: string;
};

export const StatusPill = ({ statusText, statusType, className }: StatusPillProps) => {
    const statusColor: StatusColor = {
        approved: 'bg-brand-green',
        initiated: 'bg-yellow-600',
        rejected: 'bg-brand-red',
        canceled: 'bg-brand-red',
        active: 'bg-brand-green',
        inactive: 'bg-brand-red',
        pending: 'bg-yellow-600',
        update: 'bg-yellow-600'
    };

    return (
        <span
            className={cn(
                'text-center px-2 w-fit text-2xs text-brand-neutral-200 flex justify-center rounded-full capitalize whitespace-nowrap',
                statusColor[statusType],
                className
            )}>
            {statusText}
        </span>
    );
};

export const ColumnStatusPill = ({ status }: { status: string }) => {
    const statusType = status.toLowerCase() as StatusTypes;
    return <StatusPill statusType={statusType} statusText={status} />;
};
